/**
 * Turn a Luxon format string (the platform's PLATFORM_DATE_FORMAT, e.g.
 * `dd/LL/yyyy`) into a friendly placeholder pattern (`DD/MM/YYYY`) for the
 * editor's date-field preview. Longer tokens are mapped before shorter ones.
 */
export function humanDatePattern(luxonFormat: string): string {
  const rules: Array<[RegExp, string]> = [
    [/yyyy/g, 'YYYY'],
    [/yy/g, 'YY'],
    [/LLLL/g, 'Month'],
    [/MMMM/g, 'Month'],
    [/LLL/g, 'Mon'],
    [/MMM/g, 'Mon'],
    [/LL/g, 'MM'],
    [/MM/g, 'MM'],
    [/dd/g, 'DD'],
    [/d/g, 'D'],
    [/HH/g, 'HH'],
    [/hh/g, 'hh'],
    [/mm/g, 'mm'],
    [/ss/g, 'ss'],
    [/cccc/g, 'Day'],
    [/EEEE/g, 'Day'],
  ];
  let out = luxonFormat;
  for (const [re, rep] of rules) out = out.replace(re, rep);
  return out;
}
